// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"U0-z"};